import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('users', {
    currentUser: (state) => state.currentUser,
    getUserCompleted: (state) => state.getUserCompleted,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions('auth', ['logIn', 'logOut'])
export const socialAuthMethods = mapActions('auth', ['loginWith'])

export const signinComputed = mapState('auth', {
  authenticationLoading: (state) => state.authenticationLoading,
})
export const signupComputed = {
  ...mapState('signup', {
    registrationCompleted: (state) => state.registrationCompleted,
    registrationError: (state) => state.registrationError,
    registrationLoading: (state) => state.registrationLoading,
    registrationErrorMessage: (state) => state.registrationErrorMessage,
  }),
}

export const signupMethods = mapActions('signup', ['createAccount'])

export const passwordResetMethods = mapActions('password',
  ['sendPasswordResetEmail'])

export const passwordResetComputed = {
  ...mapState('password', {
    emailCompleted: (state) => state.emailCompleted,
    emailError: (state) => state.emailError,
    emailLoading: (state) => state.emailLoading,
  }),
}

export const passwordResetConfirmMethods = mapActions('password',
  ['resetPassword'])

export const passwordResetConfirmComputed = {
  ...mapState('password', {
    resetCompleted: (state) => state.resetCompleted,
    resetError: (state) => state.resetError,
    resetLoading: (state) => state.resetLoading,
  }),
}
